import { render } from "./Tal_commonConfirmPop.vue?vue&type=template&id=1d90057c&scoped=true"
import script from "./Tal_commonConfirmPop.vue?vue&type=script&lang=js"
export * from "./Tal_commonConfirmPop.vue?vue&type=script&lang=js"

import "./Tal_commonConfirmPop.vue?vue&type=style&index=0&id=1d90057c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\SAEUM\\Desktop\\teampl-project\\github\\unibuzzy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d90057c"]])

export default __exports__